
import Vue from 'vue';
import Component from "vue-class-component";
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import {
    factory, PositionLevelModel, PositionsClient, ResultError,
    SysAdminPositionsClient,
    UpsertPositionRequest
} from "@/api-client";
import {translateTrueFalse} from "@/features/shared/TrueFalseTranslator";
import toasts from "@/components/Toasts";
import LabelOptional from "@/features/shared/components/LabelOptional.vue";
import AdministrationDetailviewLayout from "@/features/administration/AdministrationDetailviewLayout.vue";
import {Route} from "vue-router";
import {Prop} from "vue-property-decorator";
import ErrorsSummary from "@/components/ErrorsSummary.vue";

@Component({
    components: {
        HeadingWave,
        LabelOptional,
        AdministrationDetailviewLayout,
        ErrorsSummary
    },
})
export default class UpsertPosition extends Vue {
    async beforeRouteEnter(to: Route, from: Route, next: Function) {
        try {
            if (to.params.id) {
                const positionToUpdate = await new SysAdminPositionsClient().details(to.params.id);

                to.meta!.props.preloadedModel = new UpsertPositionRequest({
                    id: positionToUpdate.id,
                    nameEng: positionToUpdate.nameEng,
                    nameEst: positionToUpdate.nameEst,
                    levelKey: positionToUpdate.levelKey,
                    responsibilitiesEng: positionToUpdate.responsibilitiesEng,
                    responsibilitiesEst: positionToUpdate.responsibilitiesEst,
                    additionalInformation: positionToUpdate.additionalInformation,
                    isActive: positionToUpdate.isActive
                });
            }

            to.meta!.props.positionLevelOptions = await new PositionsClient().levels();
            next();
        } catch (e) {
            next(e);
        }
    }

    @Prop({required: false, default: () => factory.create(UpsertPositionRequest)})
    preloadedModel!: UpsertPositionRequest;

    @Prop({required: true})
    positionLevelOptions!: PositionLevelModel[];

    model = this.preloadedModel;

    validationErrors: ResultError = ResultError.createEmpty();

    yesNoOptions = [
        {value: true, text: translateTrueFalse(true)},
        {value: false, text: translateTrueFalse(false)}
    ];

    async created() {
        this.model.levelKey = this.model.levelKey || this.positionLevelOptions[0]?.key;
        if (this.model.isActive == null)
            this.model.isActive = true;
    }

    async save() {
        this.validationErrors = ResultError.createEmpty();

        await new SysAdminPositionsClient().upsert(this.model)
            .then(
                successResponse => {
                    this.$router.push({name: 'positions'});
                    toasts.success(this.$ls.Administration_Positions_Toasts_SuccessfullySaved);
                },
                (errorResponse: ResultError) => {
                    this.validationErrors = errorResponse;
                    toasts.failure(this.$ls.Global_Toast_ActionFailureWithErrorsAbove);
                });
    }
}
